module.exports = __webpack_public_path__ + "static/media/app_btn_mc.32ad4788.png";